import { fileOptionalValidate, fileRequiredValidate } from "validators";
import * as yup from "yup";

const createFleeValidator = yup
  .object({
    brand: yup.string().required("Brand is required"),
    model: yup.string().required("Model is required"),
    color: yup.string().required("Color is required"),
    fleet_model_id: yup.string().required("Fleet type is required"),
    plate_number: yup.string().required("Plate number is required"),
    license_number: yup.string().required("License number is required"),
    brand_number: yup.string().required("Brand number is required"),
    production_year: yup
      .string()
      .required("Production year is required")
      .test(
        "is-digit",
        "Production year must be number only",
        (value: any) => value.trim().length > 0 && !isNaN(Number(value))
      ),
    door_number: yup
      .string()
      .required("Door number is required")
      .test(
        "is-digit",
        "Door number must be number only",
        (value: any) => value.trim().length > 0 && !isNaN(Number(value))
      ),
    passenger_seat: yup
      .string()
      .required("Passenger seat is required")
      .test(
        "is-digit",
        "Passenger seat must be number only",
        (value: any) => value.trim().length > 0 && !isNaN(Number(value))
      ),
    has_tinted_windows: yup.boolean().default(false),
    has_ac: yup.boolean().default(false),
    license_image: yup
      .mixed()
      .required("License image is required")
      .test("file-required", "License image is required", fileRequiredValidate),
    image: yup
      .mixed()
      .required("Fleet image is required")
      .test("file-required", "Fleet image is required", fileRequiredValidate),
    category: yup.string().required("Fleet category is required"),
  })
  .required();

export default createFleeValidator;

export const updateFleeValidator = yup
  .object({
    brand: yup.string().nullable(),
    model: yup.string().nullable(),
    color: yup.string().nullable(),
    fleet_model_id: yup.string().nullable(),
    plate_number: yup.string().nullable(),
    license_number: yup.string().nullable(),
    brand_number: yup.string().nullable(),
    production_year: yup
      .string()
      .nullable()
      .test(
        "is-digit",
        "Production year must be number only",
        (value: any) => !value || (value.trim().length > 0 && !isNaN(Number(value)))
      ),
    door_number: yup
      .string()
      .nullable()
      .test(
        "is-digit",
        "Door number must be number only",
        (value: any) => !value || (value.trim().length > 0 && !isNaN(Number(value)))
      ),
    passenger_seat: yup
      .string()
      .nullable()
      .test(
        "is-digit",
        "Passenger seat must be number only",
        (value: any) => !value || (value.trim().length > 0 && !isNaN(Number(value)))
      ),
    has_tinted_windows: yup.boolean().nullable(),
    has_ac: yup.boolean().nullable(),
    license_image: yup
      .mixed()
      .nullable()
      .test("image-required", "Image is required", fileOptionalValidate),
    image: yup
      .mixed()
      .nullable()
      .test("image-required", "Image is required", fileOptionalValidate),
    category: yup.string().nullable(),
  })
  .required();
